export default __webpack_public_path__ + "static/media/chevron-right@1x.67ce28be.svg";